import { cn } from "~/lib/utils"
import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"
import { cva, type VariantProps } from "class-variance-authority"

const separatorVariants = cva("h-separator", {
  variants: {
    orientation: {
      horizontal: "h-separator--horizontal",
      vertical: "h-separator--vertical",
    },
    size: {
      sm: "h-separator--sm",
    },
    fullWidth: {
      true: "h-separator--full",
    },
    variant: {
      default: "",
      light: "h-separator--light",
    },
  },
})

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> &
    VariantProps<typeof separatorVariants>
>(
  (
    {
      className,
      orientation = "horizontal",
      decorative = true,
      size,
      fullWidth,
      variant,
      ...props
    },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        separatorVariants({ orientation, size, fullWidth, variant }),
        className,
      )}
      asChild={true}
      {...props}
    >
      <hr />
    </SeparatorPrimitive.Root>
  ),
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator }
